import React, { useState } from 'react';
import { FaBars } from 'react-icons/fa6';
import logo from '../../images/download-removebg-preview.png';
import { motion } from 'framer-motion';

const NavBar = ({ dark }) => {
  const [navActive, setNavActive] = useState(false);

  const handleClick = () => {
    setNavActive(!navActive);
  };

  return (
    <motion.main
      className={`w-screen ${dark ? 'bg-black text-white' : ''}`}
      initial={{ x: -1000 }}
      animate={{ x: 0 }}
      transition={{ type: 'easeInOut', duration: 1 }}
    >
      <div className="navHead mx-auto flex flex-row w-[80%] items-center justify-between  ">
        <img src={logo} alt="" className=" w-[100px]" />
        <div
          className={`nav flex flex-row items-center gap-4 ${
            navActive ? 'show' : ''
          }  `}
        >
          <ul
            className={`ul flex flex-row gap-[50px]  font-extrabold cursor-pointer`}
          >
            <a href={'#home'}>Home</a>
            <a href={'#about'}>About</a>
            <a href={'#project'}>Project</a>
          </ul>
          <a href={'#contact'}>
            <button className="btn btn-outline btn-warning">Contact Me</button>
          </a>
        </div>
        <FaBars
          className={`bars size-10  hidden ${!dark ? 'text-black' : ''}`}
          onClick={handleClick}
        />
      </div>
    </motion.main>
  );
};

export default NavBar;
